(function () {
  'use strict';

  var RECOMMENDATIONS = {
    soft_matte: {
      name: 'Matte Mystic',
      type: 'VIIMPII Matte Liquid Lipstick',
      desc: 'Extreme lightweight soft matte with 22hr wear — perfect for bold, everyday & glam vibes.',
      link: '/collections/all'
    },
    creamy_matte: {
      name: 'Velvet Wand',
      type: 'Creamy Matte Lipstick',
      desc: 'Buttery glide with luminous matte finish — your comfort-wear essential.',
      link: '/collections/all'
    },
    glossy_tint: {
      name: 'Fairy Kiss',
      type: 'Lip Gloss',
      desc: 'High-shine gloss that transforms into a soft tint — magic in every swipe.',
      link: '/collections/all'
    }
  };

  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function qsa(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function initFaq() {
    qsa('.viimpii-faq__question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.viimpii-faq__item');
        if (item) item.classList.toggle('is-open');
      });
    });
  }

  function initSmoothScroll() {
    qsa('a.viimpii-scroll-link, a[href^="#viimpii"], a[href="#shade-finder"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('href');
        if (!id || id === '#') return;
        var target = qs(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) {
      qsa('.viimpii-fade-in').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.01, rootMargin: '80px 0px 80px 0px' });

    qsa('.viimpii-fade-in:not(.is-visible)').forEach(function (el) {
      observer.observe(el);
    });

    // Reveal anything already on screen without waiting for a second paint
    qsa('.viimpii-fade-in:not(.is-visible)').forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight + 80 && rect.bottom > -80) {
        el.classList.add('is-visible');
        observer.unobserve(el);
      }
    });
  }

  function initShadeFinder() {
    qsa('[data-mm-shade-finder]').forEach(function (root) {
      initOneShadeFinder(root);
    });
  }

  function initOneShadeFinder(root) {
    var carousel = qs('[data-mm-carousel]', root);
    var track = qs('[data-mm-track]', root);
    var viewport = qs('[data-mm-viewport]', root);
    var prevBtn = qs('[data-mm-prev]', root);
    var nextBtn = qs('[data-mm-next]', root);
    var jsonEl = qs('[data-mm-product-json]', root);

    if (!carousel || !track || !viewport) return;

    var productData = null;
    if (jsonEl) {
      try { productData = JSON.parse(jsonEl.textContent); } catch (e) { productData = null; }
    }

    var originalSlides = Array.prototype.slice.call(track.querySelectorAll('[data-mm-slide]:not([data-mm-clone])'));
    var total = originalSlides.length;
    if (!total) return;

    var currentIndex = 0;
    var selectedShade = null;
    var autoplayTimer = null;
    var touchStartX = 0;
    var touchStartY = 0;
    var touchDeltaX = 0;
    var touchLastX = 0;
    var touchLastTime = 0;
    var touchVelocity = 0;
    var isDragging = false;
    var dragAxis = null; /* 'x' | 'y' | null */
    var suppressClick = false;
    var dragRaf = 0;

    function isMobileCarousel() {
      return window.innerWidth <= 749;
    }

    function getSlidesPerView() {
      if (window.innerWidth <= 749) return 1;
      if (window.innerWidth <= 1024) return 2;
      return 4;
    }

    function getCarouselGap() {
      if (!originalSlides.length) return isMobileCarousel() ? 12 : 20;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap);
      if (!isNaN(gap) && gap > 0) return gap;
      return isMobileCarousel() ? 12 : 20;
    }

    function getMaxIndex() {
      if (isMobileCarousel()) return Math.max(0, total - 1);
      return Math.max(0, total - getSlidesPerView());
    }

    function getSlideWidth() {
      var slide = originalSlides[0];
      if (slide && slide.offsetWidth > 0) return slide.offsetWidth;
      if (isMobileCarousel()) {
        return Math.min(viewport.clientWidth * 0.72, 260);
      }
      var perView = getSlidesPerView();
      var gap = getCarouselGap();
      return (viewport.clientWidth - gap * (perView - 1)) / perView;
    }

    function getSlideOffset(index) {
      var slideW = getSlideWidth();
      var gap = getCarouselGap();
      /* Mobile: left-align (no center peek empty space before first card) */
      return index * (slideW + gap);
    }

    function applyTrackTransform(offset, animate) {
      var duration = isMobileCarousel() ? '0.32s' : '0.45s';
      var easing = isMobileCarousel()
        ? 'cubic-bezier(0.22, 1, 0.36, 1)'
        : 'cubic-bezier(0.4, 0, 0.2, 1)';
      track.style.transition = animate !== false ? 'transform ' + duration + ' ' + easing : 'none';
      track.style.transform = 'translate3d(' + (-offset) + 'px, 0, 0)';
    }

    function setTrackPosition(animate) {
      applyTrackTransform(getSlideOffset(currentIndex), animate);
    }

    function updateControls() {
      var maxIdx = getMaxIndex();
      var allVisible = maxIdx === 0;

      if (prevBtn) {
        prevBtn.disabled = currentIndex <= 0;
        prevBtn.classList.toggle('is-disabled', currentIndex <= 0);
        prevBtn.classList.toggle('is-hidden', allVisible);
      }
      if (nextBtn) {
        nextBtn.disabled = currentIndex >= maxIdx;
        nextBtn.classList.toggle('is-disabled', currentIndex >= maxIdx);
        nextBtn.classList.toggle('is-hidden', allVisible);
      }
    }

    function endTouchDrag() {
      if (!isDragging) return;
      isDragging = false;
      dragAxis = null;
      if (dragRaf) {
        window.cancelAnimationFrame(dragRaf);
        dragRaf = 0;
      }
      track.classList.remove('is-dragging');
      viewport.classList.remove('is-touching');

      var distanceThreshold = isMobileCarousel() ? 36 : 48;
      var velocityThreshold = 0.35;
      var flicked = Math.abs(touchVelocity) > velocityThreshold;
      var shouldMove = Math.abs(touchDeltaX) > distanceThreshold || flicked;

      if (shouldMove) {
        suppressClick = true;
        window.setTimeout(function () { suppressClick = false; }, 280);
        var direction = touchDeltaX !== 0 ? touchDeltaX : -touchVelocity;
        if (flicked && Math.abs(touchDeltaX) < distanceThreshold) {
          direction = -touchVelocity;
        }
        if (direction < 0) goNext();
        else goPrev();
      } else {
        setTrackPosition(true);
      }

      touchDeltaX = 0;
      touchVelocity = 0;
      startAutoplay();
    }

    function goTo(index) {
      var maxIdx = getMaxIndex();
      currentIndex = Math.max(0, Math.min(index, maxIdx));
      setTrackPosition(true);
      updateControls();
    }

    function goNext() {
      if (currentIndex >= getMaxIndex()) return;
      goTo(currentIndex + 1);
    }

    function goPrev() {
      if (currentIndex <= 0) return;
      goTo(currentIndex - 1);
    }

    function resolveShade(card) {
      if (!card) return null;
      var name = card.getAttribute('data-shade-name') || '';
      var idx = parseInt(card.getAttribute('data-shade-index'), 10);
      if (isNaN(idx) && productData && productData.shades) {
        productData.shades.forEach(function (s, i) {
          if (s.name === name) idx = i;
        });
      }
      if (isNaN(idx)) idx = 0;
      var info = productData && productData.shades ? productData.shades[idx] : null;
      var variantId = card.getAttribute('data-variant-id') || (info ? info.variantId : '') || '';
      var productUrl = card.getAttribute('href') || card.getAttribute('data-product-url') || (info ? info.url : '') || '';
      return { name: name, variantId: variantId, index: idx, url: productUrl };
    }

    function selectShade(card) {
      var shade = resolveShade(card);
      if (!shade) return null;
      selectedShade = shade;

      qsa('[data-mm-slide]', track).forEach(function (c) {
        c.classList.toggle('is-selected', c.getAttribute('data-shade-name') === shade.name);
      });

      return shade;
    }

    function addShadeToCart(shade, btn) {
      if (!shade) return;
      var variantId = shade.variantId;
      if (!variantId) {
        // Never fall back to a default/wrong shade — open the product instead
        if (shade.url) {
          window.location.href = shade.url;
          return;
        }
        if (btn) {
          var prevLabel = btn.textContent;
          btn.textContent = 'Pick a shade';
          setTimeout(function () {
            btn.textContent = prevLabel;
          }, 1800);
        }
        return;
      }

      if (btn) {
        btn.disabled = true;
        btn.classList.add('is-loading');
      }

      addToCart(variantId, 1, { Shade: shade.name })
        .then(function () {
          var trigger = qs('[data-testid="cart-drawer-trigger"]');
          if (trigger) trigger.click();
          else window.location.href = '/cart';
        })
        .catch(function () {
          window.location.href = '/cart';
        })
        .finally(function () {
          if (btn) {
            btn.disabled = false;
            btn.classList.remove('is-loading');
          }
        });
    }

    function startAutoplay() {
      stopAutoplay();
      if (root.getAttribute('data-autoplay') !== 'true') return;
      var speed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 5;
      autoplayTimer = window.setInterval(function () {
        if (currentIndex >= getMaxIndex()) {
          stopAutoplay();
          return;
        }
        goNext();
      }, speed * 1000);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function equalizeSlideHeights() {
      var slides = track.querySelectorAll('[data-mm-slide]');
      if (!slides.length) return;

      Array.prototype.forEach.call(slides, function (slide) {
        slide.style.height = '';
      });

      var maxHeight = 0;
      Array.prototype.forEach.call(slides, function (slide) {
        maxHeight = Math.max(maxHeight, slide.offsetHeight);
      });

      if (maxHeight < 1) return;

      var target = Math.ceil(maxHeight) + 'px';
      Array.prototype.forEach.call(slides, function (slide) {
        slide.style.height = target;
      });
    }

    function layoutCarousel(animate) {
      equalizeSlideHeights();
      setTrackPosition(animate);
      updateControls();
    }

    setTrackPosition(false);
    updateControls();
    window.requestAnimationFrame(function () {
      equalizeSlideHeights();
      setTrackPosition(false);
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { stopAutoplay(); goPrev(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stopAutoplay(); goNext(); });

    track.addEventListener('click', function (e) {
      if (suppressClick) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      var selectBtn = e.target.closest('[data-select-shade]');
      var card = e.target.closest('[data-mm-slide]');
      if (!selectBtn || !card) return;

      e.preventDefault();
      stopAutoplay();
      var shade = selectShade(card);
      if (shade) addShadeToCart(shade, selectBtn);
    });

    function onPointerDown(clientX, clientY) {
      touchStartX = clientX;
      touchStartY = clientY;
      touchLastX = clientX;
      touchLastTime = Date.now();
      touchDeltaX = 0;
      touchVelocity = 0;
      dragAxis = null;
      isDragging = true;
      track.classList.add('is-dragging');
      viewport.classList.add('is-touching');
      stopAutoplay();
    }

    function onPointerMove(clientX, clientY, event) {
      if (!isDragging) return;

      var dx = clientX - touchStartX;
      var dy = clientY - touchStartY;

      if (!dragAxis) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        dragAxis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (dragAxis === 'y') {
          isDragging = false;
          track.classList.remove('is-dragging');
          viewport.classList.remove('is-touching');
          return;
        }
      }

      if (dragAxis !== 'x') return;

      if (event && event.cancelable) event.preventDefault();

      var now = Date.now();
      var dt = Math.max(1, now - touchLastTime);
      touchVelocity = (clientX - touchLastX) / dt;
      touchLastX = clientX;
      touchLastTime = now;
      touchDeltaX = dx;

      if (dragRaf) window.cancelAnimationFrame(dragRaf);
      dragRaf = window.requestAnimationFrame(function () {
        var base = getSlideOffset(currentIndex);
        var maxIdx = getMaxIndex();
        var nextOffset = base - touchDeltaX;
        /* Soft rubber-band at edges */
        if (currentIndex <= 0 && touchDeltaX > 0) {
          nextOffset = base - touchDeltaX * 0.35;
        } else if (currentIndex >= maxIdx && touchDeltaX < 0) {
          nextOffset = base - touchDeltaX * 0.35;
        }
        applyTrackTransform(nextOffset, false);
      });
    }

    viewport.addEventListener('touchstart', function (e) {
      if (e.touches.length > 1) return;
      onPointerDown(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });

    viewport.addEventListener('touchmove', function (e) {
      if (!isDragging || e.touches.length > 1) return;
      onPointerMove(e.touches[0].clientX, e.touches[0].clientY, e);
    }, { passive: false });

    viewport.addEventListener('touchend', endTouchDrag, { passive: true });
    viewport.addEventListener('touchcancel', endTouchDrag, { passive: true });

    /* Desktop mouse drag support */
    var mouseActive = false;
    viewport.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      mouseActive = true;
      onPointerDown(e.clientX, e.clientY);
    });
    window.addEventListener('mousemove', function (e) {
      if (!mouseActive) return;
      onPointerMove(e.clientX, e.clientY, e);
    });
    window.addEventListener('mouseup', function () {
      if (!mouseActive) return;
      mouseActive = false;
      endTouchDrag();
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        if (currentIndex > getMaxIndex()) {
          currentIndex = getMaxIndex();
        }
        layoutCarousel(false);
      }, 120);
    });

    qsa('img', track).forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () {
        equalizeSlideHeights();
      }, { once: true });
    });

    startAutoplay();
    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
  }

  function initVideoReviews() {
    qsa('[data-vr-section]').forEach(function (root) {
      initOneVideoReviews(root);
    });

    if (!window.__viimpiiVrEscapeBound) {
      window.__viimpiiVrEscapeBound = true;
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        qsa('[data-vr-modal]').forEach(function (modal) {
          if (modal.hidden) return;
          var media = qs('[data-vr-modal-media]', modal);
          if (media) media.innerHTML = '';
          modal.hidden = true;
          document.body.style.overflow = '';
        });
      });
    }
  }

  function initOneVideoReviews(root) {
    var strip = qs('[data-vr-strip]', root);
    var modal = qs('[data-vr-modal]', root);
    var modalMedia = qs('[data-vr-modal-media]', root);
    if (!strip) return;

    function closeVideoModal() {
      if (!modal || !modalMedia) return;
      modalMedia.innerHTML = '';
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    function openVideoModal(card) {
      if (!modal || !modalMedia || !card) return;
      var type = card.getAttribute('data-vr-type') || '';
      var src = card.getAttribute('data-vr-src') || '';
      var hostId = card.getAttribute('data-vr-id') || '';
      if (!type) return;

      modalMedia.innerHTML = '';

      if (type === 'mp4' && src) {
        var video = document.createElement('video');
        video.src = src;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        modalMedia.appendChild(video);
        video.play().catch(function () {});
      } else if (type === 'youtube' && hostId) {
        var yt = document.createElement('iframe');
        yt.src = 'https://www.youtube.com/embed/' + hostId + '?autoplay=1&rel=0&playsinline=1';
        yt.allow = 'autoplay; encrypted-media; fullscreen';
        yt.allowFullscreen = true;
        yt.title = 'Customer video review';
        modalMedia.appendChild(yt);
      } else if (type === 'vimeo' && hostId) {
        var vm = document.createElement('iframe');
        vm.src = 'https://player.vimeo.com/video/' + hostId + '?autoplay=1';
        vm.allow = 'autoplay; encrypted-media; fullscreen';
        vm.allowFullscreen = true;
        vm.title = 'Customer video review';
        modalMedia.appendChild(vm);
      } else {
        return;
      }

      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    strip.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-vr-open]');
      if (!openBtn) return;
      var card = openBtn.closest('[data-vr-card]');
      if (!card) return;
      e.preventDefault();
      openVideoModal(card);
    });

    qsa('[data-vr-close]', root).forEach(function (btn) {
      btn.addEventListener('click', closeVideoModal);
    });
  }

  function initQuickView() {
    var overlay = qs('#viimpii-quick-view');
    if (!overlay) return;

    function openModal(data) {
      var title = qs('[data-qv-title]', overlay);
      var subtitle = qs('[data-qv-subtitle]', overlay);
      var desc = qs('[data-qv-desc]', overlay);
      var price = qs('[data-qv-price]', overlay);
      var shades = qs('[data-qv-shades]', overlay);
      var shop = qs('[data-qv-shop]', overlay);

      if (title) title.textContent = data.title || 'Product';
      if (subtitle) subtitle.textContent = data.subtitle || '';
      if (desc) desc.textContent = data.desc || '';
      if (price) price.textContent = data.price || '';
      if (shades) shades.textContent = data.shades ? data.shades + ' Shades' : '';
      if (shop) shop.href = data.link || '/collections/all';

      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      overlay.hidden = true;
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.viimpii-quick-view-trigger');
      if (!btn) return;
      e.preventDefault();
      openModal({
        title: btn.getAttribute('data-qv-title'),
        subtitle: btn.getAttribute('data-qv-subtitle'),
        desc: btn.getAttribute('data-qv-desc'),
        price: btn.getAttribute('data-qv-price'),
        shades: btn.getAttribute('data-qv-shades'),
        link: btn.getAttribute('data-qv-link')
      });
    });

    qsa('[data-qv-close]', overlay).forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) closeModal();
    });
  }

  function initNewsletterPopup() {
    var popup = qs('#viimpii-newsletter-popup');
    if (!popup) return;

    var storageKey = 'viimpii_newsletter_closed';
    if (localStorage.getItem(storageKey)) return;

    var delay = parseInt(popup.getAttribute('data-delay'), 10) || 3000;

    setTimeout(function () {
      if (!localStorage.getItem(storageKey)) popup.classList.add('is-open');
    }, delay);

    var closeBtn = qs('.viimpii-popup__close', popup);
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        popup.classList.remove('is-open');
        localStorage.setItem(storageKey, '1');
      });
    }

    popup.addEventListener('click', function (e) {
      if (e.target === popup) {
        popup.classList.remove('is-open');
        localStorage.setItem(storageKey, '1');
      }
    });
  }

  function cartRoot() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }

  function getCartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function dispatchCartUpdate(cart, variantId, sections, source) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        data: {
          itemCount: cart && cart.item_count,
          variantId: String(variantId || ''),
          source: source || 'viimpii',
          sections: sections || undefined
        }
      }
    }));
  }

  function withCartDrawerAutoOpenPaused(run) {
    var drawer = document.querySelector('cart-drawer-component');
    var hadAuto = !!(drawer && drawer.hasAttribute('auto-open'));
    if (hadAuto) drawer.removeAttribute('auto-open');
    return Promise.resolve()
      .then(run)
      .finally(function () {
        if (hadAuto && drawer) {
          requestAnimationFrame(function () {
            drawer.setAttribute('auto-open', '');
          });
        }
      });
  }

  function ensureCartPriceSpinner() {
    var dialog = document.querySelector('.cart-drawer__dialog, [data-testid="cart-drawer-dialog"]');
    if (!dialog) return null;
    var el = dialog.querySelector('[data-viimpii-cart-price-loading]');
    if (el) return el;
    el = document.createElement('div');
    el.className = 'viimpii-cart-price-loading';
    el.setAttribute('data-viimpii-cart-price-loading', '');
    el.setAttribute('hidden', '');
    el.innerHTML =
      '<div class="viimpii-cart-price-loading__card" role="status" aria-live="polite">' +
      '<span class="viimpii-cart-price-loading__spin" aria-hidden="true"></span>' +
      '<p class="viimpii-cart-price-loading__text">Updating price…</p>' +
      '</div>';
    dialog.appendChild(el);
    return el;
  }

  function setCartPriceLoading(on) {
    var el = ensureCartPriceSpinner();
    if (!el) return;
    if (on) {
      el.removeAttribute('hidden');
      el.classList.add('is-visible');
      document.documentElement.classList.add('viimpii-cart-price-updating');
    } else {
      el.setAttribute('hidden', '');
      el.classList.remove('is-visible');
      document.documentElement.classList.remove('viimpii-cart-price-updating');
    }
  }
  window.setCartPriceLoading = setCartPriceLoading;

  document.addEventListener('viimpii:cart-price-loading', function (e) {
    setCartPriceLoading(!!(e.detail && e.detail.on));
  });

  function refreshCartSections(cart, sections, source) {
    return withCartDrawerAutoOpenPaused(function () {
      dispatchCartUpdate(cart, '', sections, source || 'viimpii');
    });
  }

  function cartHasByobItems(cart) {
    return (cart.items || []).some(function (item) {
      return isByobLineItem(item);
    });
  }

  function isByobLineItem(item) {
    if (!item) return false;
    var props = item.properties || {};
    if (props['_BYOB Discount'] || props['_BYOB'] || props['_BYOB Tier'] || props['Box Size'] || props['_Bundle Size']) {
      return true;
    }
    var bundleId = String(props['_Bundle ID'] || '').toLowerCase();
    if (bundleId.indexOf('byob') === 0) return true;
    var handle = String(item.handle || '').toLowerCase();
    return handle.indexOf('byob-') === 0;
  }

  function byobRequiredPieces(item) {
    var props = (item && item.properties) || {};
    var fromSize = parseInt(props['_Bundle Size'] || props['Box Size'] || '0', 10);
    if (fromSize > 0) return fromSize;
    var byob = String(props['_BYOB'] || '');
    var m = byob.match(/(\d+)\s*for/i);
    if (m) return parseInt(m[1], 10) || 0;
    var code = String(props['_BYOB Discount'] || '');
    var m2 = code.match(/^BYOB(\d+)OFF/i);
    if (m2) return parseInt(m2[1], 10) || 0;
    return 0;
  }

  function getByobTaggedPieceCount(cart) {
    var qty = 0;
    (cart.items || []).forEach(function (item) {
      if (!isByobLineItem(item)) return;
      if (String(item.handle || '').toLowerCase().indexOf('byob-') === 0) return;
      qty += item.quantity || 1;
    });
    return qty;
  }

  function getByobRequiredFromCart(cart) {
    var fromCode = byobCodePieceCount(getActiveByobCode(cart));
    if (fromCode > 0) return fromCode;
    var req = 0;
    (cart.items || []).forEach(function (item) {
      if (!isByobLineItem(item)) return;
      var r = byobRequiredPieces(item);
      if (r > req) req = r;
    });
    if (req <= 0) {
      try {
        req = parseInt(sessionStorage.getItem('viimpii_byob_size') || '0', 10) || 0;
      } catch (e) {}
    }
    return req;
  }

  function cartHasCompleteByob(cart) {
    var need = getByobRequiredFromCart(cart);
    var have = getByobTaggedPieceCount(cart);
    return need > 0 && have === need;
  }

  function getByobGroups(cart) {
    var groups = {};
    (cart.items || []).forEach(function (item) {
      if (!isByobLineItem(item)) return;
      var handle = String(item.handle || '').toLowerCase();
      if (handle.indexOf('byob-') === 0) {
        groups[item.key] = {
          required: 1,
          qty: item.quantity || 1,
          items: [item],
          isSku: true
        };
        return;
      }
      var props = item.properties || {};
      var id = String(props['_Bundle ID'] || '__byob__');
      if (!groups[id]) groups[id] = { required: 0, qty: 0, items: [], isSku: false };
      groups[id].items.push(item);
      groups[id].qty += item.quantity || 1;
      var req = byobRequiredPieces(item);
      if (req > groups[id].required) groups[id].required = req;
    });
    return groups;
  }

  /** Not exact tier size (3→2 or 3→4, same for 4/6/8) → broken. */
  function getBrokenByobItems(cart) {
    var need = getByobRequiredFromCart(cart);
    var have = getByobTaggedPieceCount(cart);
    if (need > 0 && have > 0 && have !== need) {
      var all = [];
      (cart.items || []).forEach(function (item) {
        if (!isByobLineItem(item)) return;
        if (String(item.handle || '').toLowerCase().indexOf('byob-') === 0) return;
        all.push(item);
      });
      return all;
    }
    var groups = getByobGroups(cart);
    var broken = [];
    Object.keys(groups).forEach(function (id) {
      var g = groups[id];
      if (g.isSku) return;
      if (g.required > 0 && g.qty !== g.required) broken = broken.concat(g.items);
    });
    return broken;
  }

  function getActiveByobCode(cart) {
    if (!cart) return '';
    var attrs = cart.attributes || {};
    if (attrs.byob_discount_code) return String(attrs.byob_discount_code);
    if (attrs._byob_discount_code) return String(attrs._byob_discount_code);
    var codes = cart.discount_codes || [];
    for (var i = 0; i < codes.length; i++) {
      var c = String(codes[i].code || '');
      if (c.toUpperCase().indexOf('BYOB') === 0) return c;
    }
    try {
      return sessionStorage.getItem('viimpii_byob_discount') || '';
    } catch (e) {
      return '';
    }
  }

  function byobCodePieceCount(code) {
    var m = String(code || '').match(/^BYOB(\d+)OFF/i);
    return m ? parseInt(m[1], 10) || 0 : 0;
  }

  /**
   * Valid only when piece count === chosen tier exactly (3/4/6/8).
   * Remove 1 OR add 1 → main price for remaining items.
   */
  function isByobDiscountValid(cart) {
    var need = getByobRequiredFromCart(cart);
    var have = getByobTaggedPieceCount(cart);
    if (need <= 0 || have <= 0) return false;
    if (have !== need) return false;

    var discountedQty = 0;
    (cart.items || []).forEach(function (item) {
      var allocs = item.line_level_discount_allocations || [];
      for (var i = 0; i < allocs.length; i++) {
        var title = allocs[i].discount_application && allocs[i].discount_application.title;
        if (String(title || '').toUpperCase().indexOf('BYOB') === 0) {
          discountedQty += item.quantity || 1;
          return;
        }
      }
    });
    if (discountedQty > 0 && discountedQty !== need) return false;
    return true;
  }

  function cleanByobProps(props) {
    var next = {};
    Object.keys(props || {}).forEach(function (key) {
      if (
        key === '_BYOB' ||
        key === '_BYOB Discount' ||
        key === '_BYOB Tier' ||
        key === '_Bundle ID' ||
        key === '_Bundle Size' ||
        key === '_Bundle Type' ||
        key === '_Bundle Price' ||
        key === 'Box Size' ||
        key === 'Bundle'
      ) {
        return;
      }
      next[key] = props[key];
    });
    return next;
  }

  function cartHasByobDiscountCode(cart) {
    if (!cart) return false;
    if (cart.attributes && (cart.attributes.byob_discount_code || cart.attributes._byob_discount_code)) {
      return true;
    }
    return (cart.discount_codes || []).some(function (d) {
      return String(d.code || '').toUpperCase().indexOf('BYOB') === 0;
    });
  }

  /** Clear BYOB + Combo discount codes so the next promo can apply cleanly. */
  function clearStickyByobDiscount() {
    try {
      sessionStorage.removeItem('viimpii_byob_discount');
      sessionStorage.removeItem('viimpii_byob_size');
      sessionStorage.removeItem('viimpii_combo_discount');
    } catch (e) {}
    var sectionIds = getCartSectionIds();
    var body = {
      discount: '',
      attributes: {
        byob_discount_code: '',
        _byob_discount_code: '',
        combo_discount_code: ''
      }
    };
    if (sectionIds.length) body.sections = sectionIds.join(',');
    return fetch(cartRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function applyPromoDiscountCode(code, attributeKey) {
    if (!code) return Promise.resolve(null);
    try {
      if (String(code).toUpperCase().indexOf('BYOB') === 0) {
        sessionStorage.setItem('viimpii_byob_discount', code);
      } else if (String(code).toUpperCase().indexOf('COMBO') === 0) {
        sessionStorage.setItem('viimpii_combo_discount', code);
      }
    } catch (e) {}
    var attrs = {
      byob_discount_code: '',
      _byob_discount_code: '',
      combo_discount_code: ''
    };
    attrs[attributeKey || 'byob_discount_code'] = code;
    var sectionIds = getCartSectionIds();
    var body = { discount: code, attributes: attrs };
    if (sectionIds.length) body.sections = sectionIds.join(',');
    return fetch(cartRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function addToCart(variantId, quantity, properties) {
    var sectionIds = getCartSectionIds();
    var payload = { id: variantId, quantity: quantity || 1 };
    if (properties && Object.keys(properties).length) {
      payload.properties = properties;
    }
    if (sectionIds.length) payload.sections = sectionIds.join(',');
    return fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function (addRes) {
        return fetch(cartRoot() + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            dispatchCartUpdate(cart, variantId, addRes && addRes.sections);
            return cart;
          });
      });
  }

  var VIIMPII_BUNDLE_KEY = 'viimpii_bundle_cart';

  function parseViimpiiPrice(priceLabel) {
    if (!priceLabel) return 0;
    var match = String(priceLabel).replace(/[^\d.]/g, '');
    return parseFloat(match) || 0;
  }

  function formatViimpiiPrice(amount) {
    if (!amount) return '₹0';
    return '₹' + Math.round(amount).toLocaleString('en-IN');
  }

  function getViimpiiBundles() {
    try {
      var data = JSON.parse(sessionStorage.getItem(VIIMPII_BUNDLE_KEY)) || [];
      if (!data.length) return [];
      if (data[0].shades && data[0].lineTitle) return data;

      var groups = {};
      data.forEach(function (item) {
        if (!groups[item.bundleId]) {
          groups[item.bundleId] = {
            bundleId: item.bundleId,
            lineTitle: item.lineTitle,
            lineType: item.lineType,
            priceLabel: item.price,
            unitPrice: parseViimpiiPrice(item.price),
            image: item.image,
            shades: []
          };
        }
        groups[item.bundleId].shades.push({
          name: item.name,
          hex: item.hex,
          key: item.key
        });
      });
      return Object.keys(groups).map(function (key) { return groups[key]; });
    } catch (e) {
      return [];
    }
  }

  function saveViimpiiBundles(bundles) {
    sessionStorage.setItem(VIIMPII_BUNDLE_KEY, JSON.stringify(bundles));
  }

  function getViimpiiBundleShadeCount(bundles) {
    var total = 0;
    bundles.forEach(function (bundle) {
      total += (bundle.shades || []).length;
    });
    return total;
  }

  function updateViimpiiCartBubble() {
    var bundles = getViimpiiBundles();
    var bundleCount = bundles.length;
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = cart.item_count + bundleCount;
        qsa('.cart-bubble__text-count').forEach(function (el) {
          el.textContent = total > 0 ? String(total) : '';
        });
      })
      .catch(function () {
        if (bundleCount > 0) {
          qsa('.cart-bubble__text-count').forEach(function (el) {
            el.textContent = String(bundleCount);
          });
        }
      });
  }

  function addViimpiiVirtualBundle(lineData) {
    var bundles = getViimpiiBundles();
    var bundleId = lineData.bundleId || lineData.title || 'viimpii-line';
    bundles = bundles.filter(function (bundle) { return bundle.bundleId !== bundleId; });

    bundles.push({
      bundleId: bundleId,
      lineTitle: lineData.title || 'VIIMPII',
      lineType: lineData.type || '',
      priceLabel: lineData.price || '',
      unitPrice: parseViimpiiPrice(lineData.price),
      image: lineData.lineImage || '',
      shades: (lineData.shades || []).map(function (shade, idx) {
        return {
          name: shade.name,
          hex: shade.hex,
          key: bundleId + '-' + idx
        };
      })
    });

    saveViimpiiBundles(bundles);
    updateViimpiiCartBubble();
    return Promise.resolve(bundles);
  }

  function removeViimpiiBundle(bundleId) {
    var bundles = getViimpiiBundles().filter(function (bundle) {
      return bundle.bundleId !== bundleId;
    });
    saveViimpiiBundles(bundles);
    updateViimpiiCartBubble();
    if (!bundles.length) {
      var inner = qs('[data-hydration-key="cart-drawer-inner"]');
      var template = qs('#empty-cart-template');
      if (inner && template) {
        inner.innerHTML = template.innerHTML;
        var dialog = inner.closest('.cart-drawer__dialog');
        if (dialog) {
          dialog.classList.add('cart-drawer--empty');
          dialog.classList.remove('viimpii-cart-drawer--active');
        }
      }
      return;
    }
    renderViimpiiCartDrawer();
  }

  function renderViimpiiCartDrawer() {
    var bundles = getViimpiiBundles();
    var inner = qs('[data-hydration-key="cart-drawer-inner"]');
    if (!inner || !bundles.length) return;

    var bundleCount = bundles.length;
    var cartTotal = 0;
    var html = '';

    html += '<div class="viimpii-cart-drawer">';
    html += '<div class="viimpii-cart-drawer__header">';
    html += '<div class="viimpii-cart-drawer__title-wrap">';
    html += '<p class="viimpii-cart-drawer__eyebrow">✦ VIIMPII</p>';
    html += '<h2 class="viimpii-cart-drawer__title">Your Cart <span class="viimpii-cart-drawer__count">' + bundleCount + '</span></h2>';
    html += '</div>';
    html += '<button type="button" class="viimpii-cart-drawer__close" data-viimpii-close-cart aria-label="Close">';
    html += '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M18.3 5.71a1 1 0 00-1.41 0L12 10.59 7.11 5.7A1 1 0 105.7 7.11L10.59 12l-4.89 4.89a1 1 0 101.41 1.41L12 13.41l4.89 4.89a1 1 0 001.41-1.41L13.41 12l4.89-4.89a1 1 0 000-1.4z"/></svg>';
    html += '</button></div>';

    html += '<div class="viimpii-cart-drawer__content">';

    bundles.forEach(function (bundle) {
      var count = (bundle.shades || []).length;
      var bundlePrice = bundle.priceLabel || formatViimpiiPrice(bundle.unitPrice);
      cartTotal += parseViimpiiPrice(bundlePrice);
      var manyClass = count > 10 ? ' viimpii-cart-group__swatches--many' : '';

      html += '<article class="viimpii-cart-group" data-viimpii-bundle="' + bundle.bundleId + '">';
      html += '<div class="viimpii-cart-group__card">';
      html += '<button type="button" class="viimpii-cart-group__remove" data-viimpii-remove-bundle="' + bundle.bundleId + '" aria-label="Remove ' + bundle.lineTitle + ' bundle">';
      html += '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path fill="currentColor" d="M18.3 5.71a1 1 0 00-1.41 0L12 10.59 7.11 5.7A1 1 0 105.7 7.11L10.59 12l-4.89 4.89a1 1 0 101.41 1.41L12 13.41l4.89 4.89a1 1 0 001.41-1.41L13.41 12l4.89-4.89a1 1 0 000-1.4z"/></svg>';
      html += '</button>';
      html += '<div class="viimpii-cart-group__media">';
      if (bundle.image) {
        html += '<img src="' + bundle.image + '" alt="" class="viimpii-cart-group__img" loading="lazy">';
      }
      html += '<span class="viimpii-cart-group__media-glow"></span>';
      html += '<span class="viimpii-cart-group__badge">' + count + ' Shades</span>';
      html += '</div>';
      html += '<div class="viimpii-cart-group__body">';
      html += '<p class="viimpii-cart-group__eyebrow">✦ Full Line Bundle</p>';
      html += '<h3 class="viimpii-cart-group__title">' + bundle.lineTitle + '</h3>';
      html += '<p class="viimpii-cart-group__type">' + bundle.lineType + '</p>';
      html += '<div class="viimpii-cart-group__swatches' + manyClass + '" aria-label="' + count + ' shades included">';
      (bundle.shades || []).forEach(function (shade) {
        html += '<span class="viimpii-cart-group__dot" style="background-color:' + shade.hex + '" title="' + shade.name + '"></span>';
      });
      html += '</div>';
      html += '<div class="viimpii-cart-group__price-box">';
      html += '<p class="viimpii-cart-group__price">' + bundlePrice + '</p>';
      html += '<p class="viimpii-cart-group__price-note">All ' + count + ' shades included</p>';
      html += '</div></div></div></article>';
    });

    html += '</div>';

    html += '<div class="viimpii-cart-drawer__footer">';
    html += '<div class="viimpii-cart-drawer__total">';
    html += '<span class="viimpii-cart-drawer__total-label">Bundle Total</span>';
    html += '<span class="viimpii-cart-drawer__total-price">' + formatViimpiiPrice(cartTotal) + '</span>';
    html += '</div>';
    html += '<a href="/collections/all" class="viimpii-btn viimpii-btn--gold viimpii-cart-drawer__shop">Continue Shopping</a>';
    html += '</div></div>';

    inner.innerHTML = html;
    var dialog = inner.closest('.cart-drawer__dialog');
    if (dialog) {
      dialog.classList.remove('cart-drawer--empty');
      dialog.classList.add('viimpii-cart-drawer--active');
    }

    qsa('[data-viimpii-remove-bundle]', inner).forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeViimpiiBundle(btn.getAttribute('data-viimpii-remove-bundle'));
      });
    });

    var closeBtn = qs('[data-viimpii-close-cart]', inner);
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        var trigger = qs('[data-testid="cart-drawer-trigger"]');
        if (trigger) trigger.click();
      });
    }
  }

  function addMultipleToCart(items) {
    var sectionIds = getCartSectionIds();
    var payload = { items: items };
    if (sectionIds.length) payload.sections = sectionIds.join(',');
    return fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function (addRes) {
        return fetch(cartRoot() + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            dispatchCartUpdate(cart, items[0] ? items[0].id : '', addRes && addRes.sections);
            return cart;
          });
      });
  }

  /**
   * Cart price guard:
   * - Combo pair broken → strip combo labels (auto discount already drops)
   * - BYOB incomplete (e.g. 3→2) → clear BYOB code + strip labels → main prices
   * Never re-open cart drawer while syncing (prevents layout jump / shrink).
   */
  function initComboCartGuard() {
    if (window.__viimpiiComboCartGuard) return;
    window.__viimpiiComboCartGuard = true;
    var busy = false;
    var timer = null;

    function cleanComboProps(props) {
      var next = {};
      Object.keys(props || {}).forEach(function (key) {
        if (key === '_Combo' || key === '_Combo Pair' || key === 'Combo') return;
        next[key] = props[key];
      });
      return next;
    }

    function changeLineProps(item, props) {
      var sectionIds = getCartSectionIds();
      var body = {
        id: item.key,
        quantity: item.quantity,
        properties: props
      };
      if (sectionIds.length) body.sections = sectionIds.join(',');
      return fetch(cartRoot() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json();
      });
    }

    function scheduleSync(delay) {
      if (window.__viimpiiPauseCartGuardUntil && Date.now() < window.__viimpiiPauseCartGuardUntil) {
        return;
      }
      clearTimeout(timer);
      timer = setTimeout(syncCartState, delay || 200);
    }

    function syncCartState() {
      if (busy) return;
      if (window.__viimpiiPauseCartGuardUntil && Date.now() < window.__viimpiiPauseCartGuardUntil) {
        return;
      }
      busy = true;
      fetch(cartRoot() + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var hasByobCode = cartHasByobDiscountCode(cart);
          var discountValid = isByobDiscountValid(cart);
          var need = getByobRequiredFromCart(cart);
          var have = getByobTaggedPieceCount(cart);
          var mismatched = need > 0 && have > 0 && have !== need;
          var shouldClearByob = (hasByobCode && !discountValid) || mismatched;
          var hasBrokenCombo = false;
          var pairMap = {};
          (cart.items || []).forEach(function (item) {
            var pair = item.properties && item.properties['_Combo Pair'];
            if (!pair) return;
            if (!pairMap[pair]) pairMap[pair] = 0;
            pairMap[pair] += 1;
          });
          Object.keys(pairMap).forEach(function (pair) {
            if (pairMap[pair] < 2) hasBrokenCombo = true;
          });
          var needsWork = shouldClearByob || getBrokenByobItems(cart).length > 0 || hasBrokenCombo;

          if (!needsWork) {
            return null;
          }

          setCartPriceLoading(true);

          var clearPromise = Promise.resolve(cart);
          if (shouldClearByob) {
            clearPromise = clearStickyByobDiscount().then(function (updated) {
              return updated || fetch(cartRoot() + 'cart.js', { credentials: 'same-origin' }).then(function (r) {
                return r.json();
              });
            });
          }

          return clearPromise.then(function (fresh) {
            var linesToClean = [];
            var seenKeys = {};

            function queueClean(item, props) {
              if (!item || seenKeys[item.key]) return;
              seenKeys[item.key] = true;
              linesToClean.push({ item: item, props: props });
            }

            getBrokenByobItems(fresh).forEach(function (item) {
              queueClean(item, cleanByobProps(item.properties));
            });

            if (shouldClearByob) {
              (fresh.items || []).forEach(function (item) {
                if (!isByobLineItem(item)) return;
                if (String(item.handle || '').toLowerCase().indexOf('byob-') === 0) return;
                queueClean(item, cleanByobProps(item.properties));
              });
            }

            var byPair = {};
            (fresh.items || []).forEach(function (item) {
              var pair = item.properties && item.properties['_Combo Pair'];
              if (!pair) return;
              if (!byPair[pair]) byPair[pair] = [];
              byPair[pair].push(item);
            });
            Object.keys(byPair).forEach(function (pair) {
              if (byPair[pair].length >= 2) return;
              byPair[pair].forEach(function (item) {
                queueClean(item, cleanComboProps(item.properties));
              });
            });

            if (!linesToClean.length) {
              return refreshCartSections(fresh, fresh.sections, 'viimpii-combo-guard');
            }

            var chain = Promise.resolve();
            var lastSections = null;
            linesToClean.forEach(function (entry) {
              chain = chain.then(function () {
                return changeLineProps(entry.item, entry.props).then(function (res) {
                  if (res && res.sections) lastSections = res.sections;
                  return res;
                });
              });
            });

            return chain.then(function () {
              return fetch(cartRoot() + 'cart.js', { credentials: 'same-origin' })
                .then(function (r) { return r.json(); })
                .then(function (next) {
                  return refreshCartSections(next, lastSections, 'viimpii-combo-guard');
                });
            });
          });
        })
        .catch(function () {})
        .then(function () {
          busy = false;
          setTimeout(function () {
            setCartPriceLoading(false);
          }, 160);
        });
    }

    document.addEventListener('cart:update', function (e) {
      var source = e.detail && e.detail.data && e.detail.data.source;
      if (source === 'viimpii-combo-guard') return;
      if (source === 'viimpii-byob') {
        window.__viimpiiPauseCartGuardUntil = Date.now() + 2500;
        return;
      }
      scheduleSync(250);
    });

    // Qty +/- / remove in cart drawer
    document.addEventListener('quantity-selector:update', function () {
      scheduleSync(350);
    });
    document.addEventListener(
      'click',
      function (e) {
        if (
          !e.target.closest(
            'cart-items-component [data-quantity-selector], .quantity-selector, .cart-items__remove, [data-cart-remove], button[name="remove"]'
          )
        ) {
          return;
        }
        scheduleSync(450);
      },
      true
    );

    setTimeout(function () {
      scheduleSync(500);
    }, 600);
  }

  function addLineBundleToCart(lineData) {
    var variantItems = [];
    var seen = {};

    (lineData.shades || []).forEach(function (shade) {
      if (shade.variantId && !seen[shade.variantId]) {
        seen[shade.variantId] = true;
        variantItems.push({ id: shade.variantId, quantity: 1 });
      }
    });

    if (variantItems.length > 0) {
      return addMultipleToCart(variantItems);
    }

    return addViimpiiVirtualBundle(lineData);
  }

  function openCartDrawer() {
    var trigger = qs('[data-testid="cart-drawer-trigger"]');
    if (trigger) {
      trigger.click();
      if (!getViimpiiBundles().length) return;
      fetch(cartRoot() + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart && cart.item_count > 0) return;
          setTimeout(renderViimpiiCartDrawer, 120);
        })
        .catch(function () {
          setTimeout(renderViimpiiCartDrawer, 120);
        });
      return;
    }
    window.location.href = '/cart';
  }

  function initBuyNow() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-viimpii-buy-now]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      btn.disabled = true;
      addToCart(variantId, 1)
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { btn.disabled = false; });
    });
  }

  function initAjaxCartForms() {
    qsa('.viimpii-card-form, .viimpii-luxury-card__form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var idInput = qs('input[name="id"]', form);
        var btn = qs('button[type="submit"]', form);
        if (!idInput) return;
        if (btn) btn.disabled = true;
        addToCart(idInput.value, 1)
          .then(function () { openCartDrawer(); })
          .catch(function () { if (btn) btn.disabled = false; });
      });
    });
  }

  function initMobileNav() {
    if (window.__viimpiiMobileNavBound) return;
    window.__viimpiiMobileNavBound = true;
    document.addEventListener('click', function (e) {
      var menuBtn = e.target.closest('[data-viimpii-open-drawer]');
      var shopBtn = e.target.closest('[data-viimpii-open-shop]');
      if (!menuBtn && !shopBtn) return;
      var drawerSummary = qs('#Details-menu-drawer-container summary');
      var drawer = drawerSummary && drawerSummary.closest('details');
      if (drawerSummary && drawer && !drawer.hasAttribute('open')) {
        drawerSummary.click();
      }
      if (shopBtn) {
        var acc = qs('.viimpii-shop-acc');
        if (acc) acc.open = true;
      }
    });
  }

  function initLuxuryLinesParallax() {
    var section = qs('[data-luxury-lines]');
    if (!section || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    qsa('[data-luxury-card]', section).forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        var media = qs('[data-luxury-card-media]', card);
        if (media) {
          media.style.transform = 'translate(' + (x * 10) + 'px, ' + (y * 8) + 'px) scale(1.03)';
        }
        card.style.setProperty('--tilt-x', (y * -4) + 'deg');
        card.style.setProperty('--tilt-y', (x * 4) + 'deg');
      });

      card.addEventListener('mouseleave', function () {
        var media = qs('[data-luxury-card-media]', card);
        if (media) media.style.transform = '';
        card.style.setProperty('--tilt-x', '0deg');
        card.style.setProperty('--tilt-y', '0deg');
      });
    });
  }

  function initHeroLuxury() {
    var hero = qs('[data-hero-luxury]');
    if (!hero) return;
    initHeroSlider(hero);
  }

  function initHeroSlider(hero) {
    var media = qs('.viimpii-hero__media', hero) || qs('.viimpii-hero__stage', hero);
    var track = qs('[data-hero-slides]', hero);
    var slides = qsa('[data-hero-slide]', hero);
    var dots = qsa('[data-hero-dot]', hero);
    var copyTitle = qs('[data-hero-copy-title]', hero);
    var copyDesc = qs('[data-hero-copy-desc]', hero);
    if (!media || !track || !slides.length || slides.length < 2) return;

    // Safari fix: some live .webp banner URLs are JPEG bytes — rewrite to .jpg assets.
    (function fixHeroBannerUrls() {
      function toJpg(url) {
        return String(url || '').replace(/viimpii-banner-([a-z0-9-]+)\.webp/gi, 'viimpii-banner-$1.jpg');
      }
      qsa('source[srcset]', hero).forEach(function (el) {
        var next = toJpg(el.getAttribute('srcset'));
        if (next && next !== el.getAttribute('srcset')) el.setAttribute('srcset', next);
      });
      qsa('img.viimpii-hero__photo', hero).forEach(function (img) {
        var next = toJpg(img.getAttribute('src'));
        if (next && next !== img.getAttribute('src')) img.setAttribute('src', next);
      });
    })();

    var index = 0;
    var timer = null;
    var interval = parseInt(hero.getAttribute('data-hero-interval'), 10) || 3000;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function slideWidth() {
      return media.clientWidth || hero.clientWidth || window.innerWidth;
    }

    function syncCopy() {
      var slide = slides[index];
      if (!slide) return;
      if (copyTitle) copyTitle.textContent = slide.getAttribute('data-hero-title') || '';
      if (copyDesc) {
        var desc = slide.getAttribute('data-hero-desc') || '';
        copyDesc.textContent = desc;
        copyDesc.hidden = !desc;
      }
    }

    function layout() {
      var w = slideWidth();
      slides.forEach(function (slide) {
        slide.style.flex = '0 0 ' + w + 'px';
        slide.style.width = w + 'px';
        slide.style.minWidth = w + 'px';
      });
      track.style.width = w * slides.length + 'px';
      track.style.transform = 'translate3d(-' + index * w + 'px, 0, 0)';
    }

    function syncDots() {
      dots.forEach(function (dot, i) {
        var on = i === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      syncCopy();
    }

    function goTo(next, animate) {
      index = ((next % slides.length) + slides.length) % slides.length;
      if (animate === false) {
        track.style.transition = 'none';
      } else {
        track.style.transition = '';
      }
      track.style.transform = 'translate3d(-' + index * slideWidth() + 'px, 0, 0)';
      syncDots();
      if (animate === false) {
        void track.offsetWidth;
        track.style.transition = '';
      }
    }

    function start() {
      stop();
      if (reduced) return;
      timer = window.setInterval(function () {
        goTo(index + 1);
      }, interval);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    layout();
    goTo(0, false);

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i = parseInt(dot.getAttribute('data-hero-dot'), 10) || 0;
        goTo(i);
        start();
      });
    });

    var touchX = 0;
    hero.addEventListener(
      'touchstart',
      function (e) {
        if (!e.touches || !e.touches.length) return;
        touchX = e.touches[0].clientX;
        stop();
      },
      { passive: true }
    );
    hero.addEventListener(
      'touchend',
      function (e) {
        if (!e.changedTouches || !e.changedTouches.length) {
          start();
          return;
        }
        var dx = e.changedTouches[0].clientX - touchX;
        if (Math.abs(dx) > 40) goTo(index + (dx < 0 ? 1 : -1));
        start();
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      layout();
    });

    start();
  }

  function initShadeModals() {
    var allOverlay = qs('#viimpii-shades-all');
    var detailOverlay = qs('#viimpii-shade-detail');
    if (!allOverlay || !detailOverlay) return null;

    var currentLine = null;
    var currentShadeIndex = 0;

    function parseLineData(container) {
      var jsonEl = container ? qs('[data-line-json]', container) : null;
      if (!jsonEl) jsonEl = qs('[data-line-json]');
      if (!jsonEl) return null;
      try {
        return JSON.parse(jsonEl.textContent);
      } catch (e) {
        return null;
      }
    }

    function closeOverlays() {
      allOverlay.hidden = true;
      detailOverlay.hidden = true;
      document.body.style.overflow = '';
    }

    function openAllShades(data) {
      currentLine = data;
      var title = qs('[data-all-title]', allOverlay);
      var type = qs('[data-all-type]', allOverlay);
      var count = qs('[data-all-count]', allOverlay);
      var grid = qs('[data-all-grid]', allOverlay);
      var shop = qs('[data-all-shop]', allOverlay);
      var eyebrow = qs('[data-all-eyebrow]', allOverlay);

      if (eyebrow) eyebrow.textContent = '✦ VIIMPII';
      if (title) title.textContent = data.title || '';
      if (type) type.textContent = data.type || '';
      if (count) count.textContent = (data.shades ? data.shades.length : 0) + ' enchanting shades';
      if (shop) shop.href = data.link || '/collections/all';

      if (grid) {
        grid.innerHTML = '';
        (data.shades || []).forEach(function (shade, idx) {
          var el = document.createElement('button');
          el.type = 'button';
          el.className = 'viimpii-shades-grid__item';
          el.setAttribute('data-shade-grid-index', String(idx));
          el.setAttribute('aria-label', (shade.name || 'Shade') + ' — select shade');
          el.addEventListener('click', function () {
            openShadeDetail(data, idx);
          });

          var mediaHtml;
          if (shade.imageUrl) {
            mediaHtml =
              '<span class="viimpii-shades-grid__dot viimpii-shades-grid__dot--photo">' +
              '<img src="' +
              shade.imageUrl +
              '" alt="" loading="lazy" class="viimpii-shades-grid__dot-img">' +
              '</span>';
          } else {
            mediaHtml =
              '<span class="viimpii-shades-grid__dot" style="background-color:' +
              (shade.hex || '#8b4868') +
              '"></span>';
          }

          el.innerHTML =
            mediaHtml + '<span class="viimpii-shades-grid__name">' + shade.name + '</span>';
          grid.appendChild(el);
        });
      }

      detailOverlay.hidden = true;
      allOverlay.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function openShadeDetail(data, idx) {
      currentLine = data;
      currentShadeIndex = idx;
      var shade = data.shades && data.shades[idx];
      if (!shade) return;

      var swatch = qs('[data-detail-swatch]', detailOverlay);
      var glow = qs('[data-detail-glow]', detailOverlay);
      var indexEl = qs('[data-detail-index]', detailOverlay);
      var line = qs('[data-detail-line]', detailOverlay);
      var name = qs('[data-detail-name]', detailOverlay);
      var type = qs('[data-detail-type]', detailOverlay);
      var desc = qs('[data-detail-desc]', detailOverlay);
      var price = qs('[data-detail-price]', detailOverlay);
      var shop = qs('[data-detail-shop]', detailOverlay);
      var backBtn = qs('[data-detail-back]', detailOverlay);
      var addBtn = qs('[data-detail-add-cart]', detailOverlay);

      if (swatch) {
        swatch.classList.remove('viimpii-shade-detail__swatch--photo');
        swatch.style.backgroundImage = '';
        swatch.style.backgroundColor = shade.hex || '#8b4868';
        if (shade.imageUrl) {
          swatch.classList.add('viimpii-shade-detail__swatch--photo');
          swatch.style.backgroundColor = 'transparent';
          swatch.style.backgroundImage = 'url(' + shade.imageUrl + ')';
        }
      }
      if (glow) glow.style.background = 'radial-gradient(circle, ' + (shade.hex || '#8b4868') + '55 0%, transparent 70%)';
      if (indexEl) indexEl.textContent = 'Shade ' + (idx + 1) + ' of ' + (data.shades ? data.shades.length : 0);
      if (line) line.textContent = data.title || 'VIIMPII';
      if (name) name.textContent = shade.name;
      if (type) type.textContent = data.type || '';
      if (desc) desc.textContent = shade.desc || '';
      if (price) price.textContent = data.price || '';
      if (shop) shop.href = shade.url || data.link || '/collections/all';
      if (backBtn) backBtn.hidden = false;
      if (addBtn) {
        addBtn.disabled = false;
        addBtn.classList.remove('is-loading');
        addBtn.textContent = shade.variantId ? 'Add to Cart' : 'View Shade';
      }

      allOverlay.hidden = true;
      detailOverlay.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function addCurrentShadeToCart() {
      var addBtn = qs('[data-detail-add-cart]', detailOverlay);
      if (!currentLine || !currentLine.shades) return;
      var shade = currentLine.shades[currentShadeIndex];
      if (!shade) return;

      if (!shade.variantId) {
        window.location.href = shade.url || currentLine.link || '/collections/all';
        return;
      }

      if (addBtn) {
        addBtn.disabled = true;
        addBtn.classList.add('is-loading');
        addBtn.textContent = 'Adding…';
      }

      addToCart(shade.variantId, 1, {
        Shade: shade.name || '',
        Line: currentLine.title || ''
      })
        .then(function () {
          closeOverlays();
          openCartDrawer();
        })
        .catch(function () {
          if (shade.url) window.location.href = shade.url;
          else window.location.href = currentLine.link || '/cart';
        })
        .finally(function () {
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.classList.remove('is-loading');
            addBtn.textContent = 'Add to Cart';
          }
        });
    }

    if (!allOverlay.dataset.bound) {
      allOverlay.dataset.bound = '1';

      qsa('[data-shades-close]').forEach(function (el) {
        el.addEventListener('click', closeOverlays);
      });

      var backBtn = qs('[data-detail-back]', detailOverlay);
      if (backBtn) {
        backBtn.addEventListener('click', function () {
          if (currentLine) openAllShades(currentLine);
        });
      }

      var addBtn = qs('[data-detail-add-cart]', detailOverlay);
      if (addBtn) {
        addBtn.addEventListener('click', function (e) {
          e.preventDefault();
          addCurrentShadeToCart();
        });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && (!allOverlay.hidden || !detailOverlay.hidden)) {
          closeOverlays();
        }
      });
    }

    return {
      parseLineData: parseLineData,
      openAllShades: openAllShades,
      openShadeDetail: openShadeDetail,
      closeOverlays: closeOverlays
    };
  }

  function initMainLineCards() {
    var modals = initShadeModals();
    if (!modals) return;

    qsa('[data-main-line-card]').forEach(function (card) {
      qsa('[data-shade-open]', card).forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var data = modals.parseLineData(card);
          var idx = parseInt(btn.getAttribute('data-shade-index'), 10) || 0;
          if (!data) return;
          modals.openShadeDetail(data, idx);
        });
      });

      qsa('[data-line-open-all]', card).forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var data = modals.parseLineData(card);
          if (data) modals.openAllShades(data);
        });
        btn.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            var data = modals.parseLineData(card);
            if (data) modals.openAllShades(data);
          }
        });
      });

      qsa('[data-line-add-cart]', card).forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var data = modals.parseLineData(card);
          if (!data || !data.shades || !data.shades.length) {
            var fallback = btn.getAttribute('data-fallback-link');
            if (fallback) window.location.href = fallback;
            return;
          }
          /* Ask for shade first — never add full line on this click */
          modals.openAllShades(data);
        });
      });
    });
  }

  function initLineCollection() {
    var section = qs('[data-line-collection]');
    var modals = initShadeModals();
    if (!section || !modals) return;

    var data = modals.parseLineData(section);
    if (!data) return;

    qsa('[data-shade-product-card]', section).forEach(function (card) {
      function openCard() {
        var idx = parseInt(card.getAttribute('data-shade-index'), 10) || 0;
        modals.openShadeDetail(data, idx);
      }

      card.addEventListener('click', openCard);
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openCard();
        }
      });
    });
  }

  function initViimpiiCartDrawer() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-testid="cart-drawer-trigger"]')) return;
      // Only swap in virtual line-bundle UI when there are no real cart items
      if (!getViimpiiBundles().length) return;
      fetch(cartRoot() + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart && cart.item_count > 0) return;
          setTimeout(renderViimpiiCartDrawer, 150);
        })
        .catch(function () {
          setTimeout(renderViimpiiCartDrawer, 150);
        });
    });
    updateViimpiiCartBubble();
  }

  function initDrawerBrand() {
    var drawer = qs('.menu-drawer');
    if (!drawer) return;

    var logoSrc = document.querySelector('[data-viimpii-logo]');
    if (!logoSrc) return;

    var nav = qs('.menu-drawer__navigation', drawer);
    if (!nav) return;

    var existingBrand = qs('.viimpii-drawer-brand', drawer);
    if (existingBrand) existingBrand.remove();

    var brand = document.createElement('a');
    brand.className = 'viimpii-drawer-brand';
    brand.href = '/';
    brand.setAttribute('aria-label', 'VIIMPII Home');
    brand.innerHTML =
      '<img src="' +
      logoSrc.getAttribute('data-viimpii-logo') +
      '" alt="VIIMPII" width="140" height="40" loading="lazy">';

    nav.insertBefore(brand, nav.firstChild);

    var drawerDetails = qs('#Details-menu-drawer-container');
    if (drawerDetails && drawerDetails.dataset.viimpiiDrawerBrandBound !== 'true') {
      drawerDetails.dataset.viimpiiDrawerBrandBound = 'true';
      drawerDetails.addEventListener('toggle', function () {
        if (drawerDetails.open) initDrawerBrand();
      });
    }
  }

  function initAboutPage() {
    var root = qs('[data-viimpii-about]');
    if (!root) return;

    function animateCount(el) {
      if (el.dataset.vaboutAnimated === 'true') return;
      var raw = el.getAttribute('data-vabout-count');
      if (!raw) return;
      var target = parseFloat(raw.replace(/[^0-9.]/g, ''));
      if (isNaN(target)) return;
      var suffix = el.getAttribute('data-vabout-suffix') || '';
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      el.dataset.vaboutAnimated = 'true';

      if (prefersReduced) {
        el.textContent = raw + suffix;
        return;
      }

      var start = 0;
      var duration = 1600;
      var startTime = null;

      function step(ts) {
        if (!startTime) startTime = ts;
        var progress = Math.min((ts - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var current = Math.floor(start + (target - start) * eased);
        el.textContent = current + suffix;
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = raw + suffix;
      }

      requestAnimationFrame(step);
    }

    if ('IntersectionObserver' in window) {
      var revealObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          qsa('[data-vabout-count]', entry.target).forEach(animateCount);
          revealObs.unobserve(entry.target);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -30px 0px' });

      qsa('.vabout-reveal:not(.is-visible)', root).forEach(function (el) {
        revealObs.observe(el);
      });

      qsa('[data-vabout-counters], [data-vabout-impact]', root).forEach(function (el) {
        revealObs.observe(el);
      });
    } else {
      qsa('.vabout-reveal', root).forEach(function (el) { el.classList.add('is-visible'); });
      qsa('[data-vabout-count]', root).forEach(animateCount);
    }

    var showcase = qs('[data-vabout-showcase]', root);
    if (showcase) {
      var isDown = false;
      var startX = 0;
      var scrollLeft = 0;

      showcase.addEventListener('mousedown', function (e) {
        isDown = true;
        startX = e.pageX - showcase.offsetLeft;
        scrollLeft = showcase.scrollLeft;
        showcase.style.cursor = 'grabbing';
      });

      showcase.addEventListener('mouseleave', function () {
        isDown = false;
        showcase.style.cursor = '';
      });

      showcase.addEventListener('mouseup', function () {
        isDown = false;
        showcase.style.cursor = '';
      });

      showcase.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - showcase.offsetLeft;
        showcase.scrollLeft = scrollLeft - (x - startX) * 1.2;
      });
    }
  }

  function initShopCards(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var buttons = scope === document ? qsa('[data-shop-add-cart]') : scope.querySelectorAll('[data-shop-add-cart]');

    buttons.forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (btn.disabled || btn.classList.contains('is-loading')) return;

        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        btn.classList.add('is-loading');
        var label = btn.textContent;
        btn.textContent = 'Adding…';

        addToCart(variantId, 1)
          .then(function () {
            btn.classList.add('is-added');
            btn.textContent = 'Added';
            openCartDrawer();
            window.setTimeout(function () {
              btn.classList.remove('is-added');
              btn.textContent = label;
            }, 1200);
          })
          .catch(function () {
            window.location.href = '/cart';
          })
          .finally(function () {
            btn.classList.remove('is-loading');
            if (!btn.classList.contains('is-added')) {
              btn.textContent = label;
            }
          });
      });
    });
  }

  function watchShopCardGrid() {
    var grid = qs('.main-collection-grid');
    if (!grid || grid.dataset.shopWatch) return;
    grid.dataset.shopWatch = '1';

    var timer;
    var observer = new MutationObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        initShopCards(grid);
      }, 80);
    });

    observer.observe(grid, { childList: true, subtree: true });
  }

  function initMixedViewAll() {
    if (window.__viimpiiViewAllBound) return;
    window.__viimpiiViewAllBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-view-all-grid]');
      if (!btn) return;
      e.preventDefault();
      var root = btn.closest('[data-mixed-grid]');
      if (!root) return;
      var expanded = root.classList.toggle('is-expanded');
      qsa('[data-mixed-extra]', root).forEach(function (el) {
        el.hidden = !expanded;
      });
      var more = btn.getAttribute('data-label-more') || 'View All';
      var less = btn.getAttribute('data-label-less') || 'View less';
      btn.textContent = expanded ? less : more;
    });
  }

  function initShopMegaMenu() {
    if (window.__viimpiiShopMegaBound) return;
    window.__viimpiiShopMegaBound = true;

    var closeTimer = null;
    var openItem = null;

    function isMobileNav() {
      return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    }

    function eventPath(e) {
      if (typeof e.composedPath === 'function') return e.composedPath();
      var path = [];
      var node = e.target;
      while (node) {
        path.push(node);
        node = node.parentNode || node.host;
      }
      return path;
    }

    function shopItemFromEvent(e) {
      var path = eventPath(e);
      for (var i = 0; i < path.length; i++) {
        var n = path[i];
        if (!n || n.nodeType !== 1) continue;
        if (n.classList && n.classList.contains('viimpii-shop-has-mega')) return n;
        if (n.getAttribute && n.getAttribute('data-shop-parent') != null) {
          return n.closest ? n.closest('.menu-list__list-item') : n.parentElement;
        }
        if (n.classList && n.classList.contains('viimpii-shop-submenu') && n._shopHome) {
          return n._shopHome;
        }
      }
      return null;
    }

    function findSubmenu(item) {
      if (!item) return document.querySelector('.viimpii-shop-submenu[data-shop-portal="1"]');
      return item.querySelector('.viimpii-shop-submenu') ||
        document.querySelector('.viimpii-shop-submenu[data-shop-portal="1"]');
    }

    function moveToBody(item, submenu) {
      if (!submenu || submenu.parentNode === document.body) return;
      submenu._shopHome = item;
      if (!submenu._shopPlaceholder) {
        submenu._shopPlaceholder = document.createComment('viimpii-shop-submenu');
      }
      if (submenu.parentNode) {
        submenu.parentNode.insertBefore(submenu._shopPlaceholder, submenu);
      }
      submenu.setAttribute('data-shop-portal', '1');
      document.body.appendChild(submenu);
    }

    function restoreSubmenu(submenu) {
      if (!submenu || !submenu._shopPlaceholder || !submenu._shopPlaceholder.parentNode) return;
      submenu._shopPlaceholder.parentNode.insertBefore(submenu, submenu._shopPlaceholder);
      submenu._shopPlaceholder.parentNode.removeChild(submenu._shopPlaceholder);
      submenu._shopPlaceholder = null;
      submenu.removeAttribute('data-shop-portal');
      submenu.removeAttribute('style');
      submenu.removeAttribute('data-active');
    }

    function positionSubmenu(item, submenu) {
      var link = item.querySelector('[data-shop-parent]') || item.querySelector('.menu-list__link');
      if (!link || !submenu) return;
      var headerEl = document.querySelector('#header-group .header__row--top') || link;
      var top = Math.round(headerEl.getBoundingClientRect().bottom);
      var left = Math.round(link.getBoundingClientRect().left);
      var width = Math.min(360, Math.max(240, window.innerWidth - 16));
      if (left + width > window.innerWidth - 8) {
        left = Math.max(8, window.innerWidth - width - 8);
      }
      submenu.style.position = 'fixed';
      submenu.style.top = top + 'px';
      submenu.style.left = left + 'px';
      submenu.style.right = 'auto';
      submenu.style.bottom = 'auto';
      submenu.style.width = width + 'px';
      submenu.style.maxWidth = 'calc(100vw - 16px)';
      submenu.style.zIndex = '2147483000';
      submenu.style.display = 'block';
      submenu.style.visibility = 'visible';
      submenu.style.opacity = '1';
      submenu.style.clipPath = 'none';
      submenu.style.webkitClipPath = 'none';
      submenu.style.margin = '0';
      submenu.style.padding = '0';
      submenu.style.background = '#fff';
      submenu.style.pointerEvents = 'auto';
      submenu.style.transform = 'none';
      submenu.style.border = '1px solid rgba(0,0,0,0.08)';
      submenu.style.borderTop = '0';
      submenu.style.boxShadow = '0 14px 36px rgba(0,0,0,0.12)';
      submenu.setAttribute('data-active', '');
    }

    function closeAllShop() {
      window.clearTimeout(closeTimer);
      if (openItem) {
        openItem.classList.remove('is-open');
        var link = openItem.querySelector('[data-shop-parent]');
        if (link) link.setAttribute('aria-expanded', 'false');
      }
      var submenu = document.querySelector('.viimpii-shop-submenu[data-shop-portal="1"]') ||
        (openItem && openItem.querySelector('.viimpii-shop-submenu'));
      if (submenu) restoreSubmenu(submenu);
      openItem = null;
    }

    function openShopItem(item) {
      if (!item || isMobileNav()) return;
      window.clearTimeout(closeTimer);
      if (openItem === item) {
        var current = findSubmenu(item);
        if (current) positionSubmenu(item, current);
        return;
      }
      if (openItem && openItem !== item) closeAllShop();
      openItem = item;
      item.classList.add('is-open');
      var link = item.querySelector('[data-shop-parent]');
      var submenu = findSubmenu(item);
      if (link) link.setAttribute('aria-expanded', 'true');
      if (!submenu) return;
      moveToBody(item, submenu);
      positionSubmenu(item, submenu);
    }

    function onPointer(e) {
      if (isMobileNav()) return;
      var item = shopItemFromEvent(e);
      if (item) {
        openShopItem(item);
        return;
      }
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(closeAllShop, 180);
    }

    document.addEventListener('mouseover', onPointer, true);
    document.addEventListener('pointerover', onPointer, true);

    document.addEventListener('click', function (e) {
      if (isMobileNav()) return;
      var item = shopItemFromEvent(e);
      var path = eventPath(e);
      var onParent = false;
      for (var i = 0; i < path.length; i++) {
        if (path[i].getAttribute && path[i].getAttribute('data-shop-parent') != null) {
          onParent = true;
          break;
        }
      }
      if (onParent && item) {
        e.preventDefault();
        openShopItem(item);
        return;
      }
      if (!item) closeAllShop();
    }, true);

    window.addEventListener('resize', function () {
      if (openItem) {
        var submenu = findSubmenu(openItem);
        if (submenu) positionSubmenu(openItem, submenu);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllShop();
    });
  }

  function initInstagramFeed() {
    qsa('[data-vig-feed]').forEach(function (root) {
      if (root.getAttribute('data-auto') !== 'true') return;
      if (root.dataset.vigBound === '1') return;
      root.dataset.vigBound = '1';

      var igUrl = root.getAttribute('data-ig-url') || 'https://www.instagram.com/viimpii_beauty';
      var track = qs('[data-vig-track], [data-vig-grid]', root);
      var viewport = qs('[data-vig-viewport]', root) || track;
      var prevBtn = qs('[data-vig-prev]', root);
      var nextBtn = qs('[data-vig-next]', root);
      var primaryFeed = root.getAttribute('data-feed-url') || '';
      var themeFeed = root.getAttribute('data-theme-feed-url') || '';
      if (!track) return;

      function assetUrlFor(fileName, themeFeedUrl) {
        if (!fileName || !themeFeedUrl) return '';
        return themeFeedUrl.replace(/viimpii-instagram-feed\.json[^?]*/, fileName);
      }

      function normalizePosts(data) {
        if (!data) return [];
        if (Array.isArray(data)) return data;
        return data.posts || data.data || [];
      }

      function escapeAttr(value) {
        return String(value || '')
          .replace(/&/g, '&amp;')
          .replace(/"/g, '&quot;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;');
      }

      function renderPosts(posts, themeFeedUrl) {
        var html = '';
        for (var i = 0; i < posts.length; i++) {
          var post = posts[i] || {};
          var poster =
            assetUrlFor(post.assetFile, themeFeedUrl) ||
            post.mediaUrl ||
            post.media_url ||
            post.thumbnailUrl ||
            post.thumbnail_url ||
            '';
          var videoSrc = assetUrlFor(post.videoFile, themeFeedUrl);
          var isVideo = !!(videoSrc && (post.isVideo || post.mediaType === 'VIDEO' || post.videoFile));
          var permalink = post.permalink || post.permalinkUrl || post.link || igUrl;
          var alt = escapeAttr((post.caption || 'VIIMPII on Instagram').toString().slice(0, 120));
          if (!poster && !videoSrc) continue;

          html += '<article class="vig__post' + (isVideo ? ' vig__post--video' : '') + '" data-vig-card>';
          if (isVideo && videoSrc) {
            html +=
              '<video class="vig__post-video" playsinline muted loop preload="auto" autoplay poster="' +
              escapeAttr(poster) +
              '" data-vig-video src="' +
              escapeAttr(videoSrc) +
              '"></video>';
            html += '<span class="vig__reel-badge" aria-hidden="true">Reel</span>';
            html +=
              '<a class="vig__ig-open" href="' +
              escapeAttr(permalink) +
              '" target="_blank" rel="noopener noreferrer" aria-label="Open reel on Instagram">Open</a>';
          } else {
            html +=
              '<a class="vig__post-link" href="' +
              escapeAttr(permalink) +
              '" target="_blank" rel="noopener noreferrer" aria-label="Open on Instagram">' +
              '<img class="vig__post-img" src="' +
              escapeAttr(poster) +
              '" alt="' +
              alt +
              '" loading="lazy" decoding="async" width="400" height="400">' +
              '</a>';
          }
          html += '<span class="vig__post-glow" aria-hidden="true"></span>';
          html += '</article>';
        }

        if (!html) return false;
        track.innerHTML = html;
        root.classList.add('is-feed-loaded');
        bindSlider();
        bindVideos();
        updateArrows();
        return true;
      }

      function cardStep() {
        var card = qs('.vig__post', track);
        if (!card) return 220;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 14;
        return card.getBoundingClientRect().width + gap;
      }

      function updateArrows() {
        if (!viewport) return;
        var max = viewport.scrollWidth - viewport.clientWidth - 4;
        var left = viewport.scrollLeft;
        if (prevBtn) prevBtn.disabled = left <= 2;
        if (nextBtn) nextBtn.disabled = left >= max;
      }

      function bindSlider() {
        if (!viewport || viewport.dataset.vigSliderBound === '1') {
          updateArrows();
          return;
        }
        viewport.dataset.vigSliderBound = '1';

        if (prevBtn) {
          prevBtn.addEventListener('click', function () {
            viewport.scrollBy({ left: -cardStep() * 2, behavior: 'smooth' });
          });
        }
        if (nextBtn) {
          nextBtn.addEventListener('click', function () {
            viewport.scrollBy({ left: cardStep() * 2, behavior: 'smooth' });
          });
        }

        viewport.addEventListener('scroll', function () {
          window.requestAnimationFrame(updateArrows);
        }, { passive: true });

        window.addEventListener('resize', updateArrows);
      }

      function pauseAllVideos(except) {
        qsa('[data-vig-video]', root).forEach(function (video) {
          if (except && video === except) return;
          video.pause();
          var card = video.closest('[data-vig-card]');
          if (card) card.classList.remove('is-playing');
        });
      }

      function bindVideos() {
        var videos = qsa('[data-vig-video]', root);
        var canHover = window.matchMedia('(hover: hover)').matches;

        function playMuted(video, card) {
          if (!video || !card) return;
          video.muted = true;
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
          card.classList.add('is-playing');
          card.classList.remove('is-sound');
        }

        function muteAll(except) {
          videos.forEach(function (video) {
            if (except && video === except) return;
            video.muted = true;
            var card = video.closest('[data-vig-card]');
            if (card) card.classList.remove('is-sound');
          });
        }

        function syncVisibleReels() {
          if (!viewport || !videos.length) return;
          var vpRect = viewport.getBoundingClientRect();

          videos.forEach(function (video) {
            var card = video.closest('[data-vig-card]');
            if (!card) return;

            var rect = video.getBoundingClientRect();
            var visibleWidth = Math.min(rect.right, vpRect.right) - Math.max(rect.left, vpRect.left);
            var ratio = rect.width > 0 ? visibleWidth / rect.width : 0;

            if (ratio > 0.45) {
              if (video.paused) playMuted(video, card);
            } else {
              video.pause();
              video.muted = true;
              card.classList.remove('is-playing');
              card.classList.remove('is-sound');
            }
          });
        }

        videos.forEach(function (video) {
          var card = video.closest('[data-vig-card]');
          if (!card) return;

          video.addEventListener('loadeddata', function () {
            window.requestAnimationFrame(syncVisibleReels);
          });

          video.addEventListener('error', function () {
            card.classList.remove('is-playing');
            card.classList.remove('is-sound');
          });

          if (canHover) {
            card.addEventListener('mouseenter', function () {
              muteAll(video);
              video.muted = false;
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
              card.classList.add('is-playing');
              card.classList.add('is-sound');
            });

            card.addEventListener('mouseleave', function () {
              video.muted = true;
              card.classList.remove('is-sound');
              if (video.paused) playMuted(video, card);
            });
          }
        });

        if (viewport) {
          viewport.addEventListener(
            'scroll',
            function () {
              window.requestAnimationFrame(syncVisibleReels);
            },
            { passive: true }
          );
        }

        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(
            function () {
              window.requestAnimationFrame(syncVisibleReels);
            },
            { root: viewport, threshold: [0, 0.25, 0.5, 0.75, 1] }
          );
          videos.forEach(function (video) {
            io.observe(video);
          });
        }

        window.requestAnimationFrame(syncVisibleReels);
        setTimeout(syncVisibleReels, 250);
        setTimeout(syncVisibleReels, 900);
      }

      function showFallback() {
        root.classList.add('is-feed-error');
        track.innerHTML =
          '<a class="vig__post vig__post--fallback" href="' +
          escapeAttr(igUrl) +
          '" target="_blank" rel="noopener noreferrer"><span class="vig__post-fallback-label">@viimpii_beauty</span></a>';
        updateArrows();
      }

      function loadFeed(url) {
        return fetch(url, { credentials: 'omit', mode: 'cors', cache: 'no-cache' }).then(function (res) {
          if (!res.ok) throw new Error('Feed HTTP ' + res.status);
          return res.json();
        });
      }

      var chain = Promise.resolve(null);
      if (primaryFeed) {
        chain = loadFeed(primaryFeed)
          .then(function (data) {
            var posts = normalizePosts(data);
            if (!posts.length) throw new Error('Empty primary feed');
            if (!renderPosts(posts, themeFeed)) throw new Error('Render failed');
            return true;
          })
          .catch(function () {
            return null;
          });
      }

      chain
        .then(function (ok) {
          if (ok) return true;
          if (!themeFeed) throw new Error('No theme feed');
          return loadFeed(themeFeed).then(function (data) {
            var posts = normalizePosts(data);
            if (!posts.length) throw new Error('Empty theme feed');
            if (!renderPosts(posts, themeFeed)) throw new Error('Render failed');
            return true;
          });
        })
        .catch(function () {
          showFallback();
        });
    });
  }

  function initMainLinesCarousel() {
    var viewport = qs('[data-main-lines-carousel]');
    var track = viewport && qs('[data-main-lines-track]', viewport);
    if (!viewport || !track || viewport.dataset.mlBound === '1') return;
    viewport.dataset.mlBound = '1';

    var slides = [];
    var currentIndex = 0;
    var startX = 0;
    var startY = 0;
    var lastX = 0;
    var lastTime = 0;
    var velocity = 0;
    var dragDelta = 0;
    var dragging = false;
    var lockedAxis = null;
    var pointerId = null;
    var suppressClicksUntil = 0;
    var dragRaf = 0;
    var baseOffset = 0;

    function isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function refreshSlides() {
      slides = Array.prototype.slice.call(track.querySelectorAll(':scope > .viimpii-main-line'));
    }

    function getGap() {
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap);
      return !isNaN(gap) && gap > 0 ? gap : 14;
    }

    function getStep() {
      if (!slides.length) return 1;
      return slides[0].getBoundingClientRect().width + getGap();
    }

    function maxIndex() {
      return Math.max(0, slides.length - 1);
    }

    function offsetFor(index) {
      return -getStep() * index;
    }

    function applyTransform(x, animate) {
      if (animate) {
        track.style.transition = 'transform 0.48s cubic-bezier(0.22, 1, 0.36, 1)';
      } else {
        track.style.transition = 'none';
      }
      track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
    }

    function goTo(index, animate) {
      currentIndex = Math.max(0, Math.min(maxIndex(), index));
      applyTransform(offsetFor(currentIndex), animate !== false);
    }

    function onDown(clientX, clientY, id) {
      if (!isMobile()) return;
      dragging = true;
      pointerId = id;
      lockedAxis = null;
      dragDelta = 0;
      startX = clientX;
      startY = clientY;
      lastX = clientX;
      lastTime = performance.now();
      velocity = 0;
      baseOffset = offsetFor(currentIndex);
      track.style.transition = 'none';
    }

    function onMove(clientX, clientY, event) {
      if (!dragging) return;
      var dx = clientX - startX;
      var dy = clientY - startY;
      var now = performance.now();
      var dt = Math.max(1, now - lastTime);
      velocity = (clientX - lastX) / dt;
      lastX = clientX;
      lastTime = now;

      if (!lockedAxis) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        lockedAxis = Math.abs(dx) > Math.abs(dy) * 1.1 ? 'x' : 'y';
        if (lockedAxis === 'y') {
          dragging = false;
          pointerId = null;
          return;
        }
        viewport.classList.add('is-dragging');
        try {
          viewport.setPointerCapture(event.pointerId);
        } catch (err) {}
      }

      if (lockedAxis !== 'x') return;

      dragDelta = dx;
      var next = baseOffset + dx;
      /* Rubber-band at ends */
      if ((currentIndex <= 0 && dx > 0) || (currentIndex >= maxIndex() && dx < 0)) {
        next = baseOffset + dx * 0.32;
      }

      if (dragRaf) window.cancelAnimationFrame(dragRaf);
      dragRaf = window.requestAnimationFrame(function () {
        applyTransform(next, false);
      });

      if (event && event.cancelable) event.preventDefault();
    }

    function onUp() {
      if (!dragging && !viewport.classList.contains('is-dragging')) return;
      dragging = false;
      viewport.classList.remove('is-dragging');

      if (pointerId != null) {
        try {
          if (viewport.hasPointerCapture && viewport.hasPointerCapture(pointerId)) {
            viewport.releasePointerCapture(pointerId);
          }
        } catch (err) {}
      }

      if (lockedAxis === 'x' && (Math.abs(dragDelta) > 12 || Math.abs(velocity) > 0.2)) {
        var next = currentIndex;
        var threshold = getStep() * 0.18;
        if (dragDelta < -threshold || velocity < -0.28) next += 1;
        else if (dragDelta > threshold || velocity > 0.28) next -= 1;
        goTo(next, true);
        suppressClicksUntil = Date.now() + 350;
      } else if (lockedAxis === 'x') {
        goTo(currentIndex, true);
      }

      lockedAxis = null;
      pointerId = null;
      dragDelta = 0;
    }

    refreshSlides();
    goTo(0, false);

    viewport.addEventListener(
      'pointerdown',
      function (e) {
        if (!isMobile()) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        onDown(e.clientX, e.clientY, e.pointerId);
      },
      { passive: true }
    );

    viewport.addEventListener(
      'pointermove',
      function (e) {
        if (!dragging) return;
        if (pointerId != null && e.pointerId !== pointerId) return;
        onMove(e.clientX, e.clientY, e);
      },
      { passive: false }
    );

    viewport.addEventListener('pointerup', onUp, { passive: true });
    viewport.addEventListener('pointercancel', onUp, { passive: true });

    viewport.addEventListener(
      'click',
      function (e) {
        if (Date.now() > suppressClicksUntil) return;
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );

    window.addEventListener('resize', function () {
      if (!isMobile()) {
        track.style.transform = '';
        track.style.transition = '';
        return;
      }
      refreshSlides();
      goTo(currentIndex, false);
    });

    qsa('img, a', track).forEach(function (el) {
      el.setAttribute('draggable', 'false');
    });
  }

  function initScrollToTopOnReload() {
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    var nav = null;
    try {
      nav = performance.getEntriesByType('navigation')[0];
    } catch (e) {}
    var isReload = (nav && nav.type === 'reload') || (performance.navigation && performance.navigation.type === 1);
    if (isReload || !location.hash) {
      window.scrollTo(0, 0);
    }
  }

  function initComboEdit() {
    if (window.__viimpiiComboEditBound) return;
    window.__viimpiiComboEditBound = true;

    var peekState = { card: null, shade: null };

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function getPeekPanel() {
      return document.querySelector('[data-combo-peek-panel]');
    }

    function closePeek() {
      var panel = getPeekPanel();
      if (!panel) return;
      panel.hidden = true;
      panel.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('viimpii-combo-peek-open');
      peekState.card = null;
      peekState.shade = null;
    }

    function openPeekFromShade(shadeBtn, card) {
      var panel = getPeekPanel();
      if (!panel || !shadeBtn) return;

      peekState.card = card || shadeBtn.closest('[data-combo-card]');
      peekState.shade = shadeBtn;

      var name = shadeBtn.getAttribute('data-shade-name') || 'Shade';
      var price = shadeBtn.getAttribute('data-shade-price') || '';
      var hero =
        shadeBtn.getAttribute('data-shade-hero') ||
        shadeBtn.getAttribute('data-shade-image') ||
        '';
      var url = shadeBtn.getAttribute('data-product-url') || '#';
      var line =
        (peekState.card &&
          ((peekState.card.querySelector('.viimpii-combo-card__eyebrow') || {}).textContent ||
            peekState.card.getAttribute('data-combo-title'))) ||
        'Combo';

      var img = panel.querySelector('[data-combo-peek-img]');
      if (img) {
        img.src = hero;
        img.alt = name;
      }
      var lineEl = panel.querySelector('[data-combo-peek-line]');
      if (lineEl) lineEl.textContent = String(line).trim();
      var titleEl = panel.querySelector('[data-combo-peek-title]');
      if (titleEl) titleEl.textContent = name;
      var priceEl = panel.querySelector('[data-combo-peek-price]');
      if (priceEl) priceEl.textContent = price ? 'Single · ' + price : '';
      var pdp = panel.querySelector('[data-combo-peek-pdp]');
      if (pdp) pdp.setAttribute('href', url);

      var selectBtn = panel.querySelector('[data-combo-peek-select]');
      if (selectBtn) {
        var already = shadeBtn.classList.contains('is-selected');
        selectBtn.textContent = already ? 'Selected ✓' : 'Select shade';
        selectBtn.disabled = already;
      }

      panel.hidden = false;
      panel.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('viimpii-combo-peek-open');
    }

    function toggleShade(shadeBtn, card) {
      if (!shadeBtn || !card) return;
      var max = Number(card.getAttribute('data-combo-max') || 2);
      var selectedCount = card.querySelectorAll('[data-combo-shade].is-selected').length;
      var isOn = shadeBtn.classList.contains('is-selected');

      if (isOn) {
        shadeBtn.classList.remove('is-selected');
        shadeBtn.setAttribute('aria-pressed', 'false');
      } else if (selectedCount >= max) {
        var first = card.querySelector('[data-combo-shade].is-selected');
        if (first) {
          first.classList.remove('is-selected');
          first.setAttribute('aria-pressed', 'false');
        }
        shadeBtn.classList.add('is-selected');
        shadeBtn.setAttribute('aria-pressed', 'true');
      } else {
        shadeBtn.classList.add('is-selected');
        shadeBtn.setAttribute('aria-pressed', 'true');
      }
      renderCard(card);
    }

    function renderCard(card) {
      var selected = [];
      card.querySelectorAll('[data-combo-shade].is-selected').forEach(function (btn) {
        selected.push({
          id: Number(btn.getAttribute('data-variant-id') || 0),
          name: btn.getAttribute('data-shade-name') || '',
          image: btn.getAttribute('data-shade-image') || '',
          url: btn.getAttribute('data-product-url') || ''
        });
      });

      card.querySelectorAll('[data-combo-slot]').forEach(function (slot, index) {
        var item = selected[index];
        if (!item) {
          slot.classList.add('is-empty');
          slot.classList.remove('is-filled');
          slot.innerHTML =
            '<span class="viimpii-combo-card__slot-num">' +
            (index + 1) +
            '</span><span class="viimpii-combo-card__slot-label">Pick shade</span>';
          return;
        }
        slot.classList.remove('is-empty');
        slot.classList.add('is-filled');
        var thumb = item.image
          ? '<img class="viimpii-combo-card__slot-thumb" src="' +
            escapeHtml(item.image) +
            '" alt="" width="40" height="40" loading="lazy">'
          : '';
        var view =
          item.url
            ? '<button type="button" class="viimpii-combo-card__slot-view" data-combo-slot-peek data-variant-id="' +
              item.id +
              '">View ✦</button>'
            : '';
        slot.innerHTML =
          '<span class="viimpii-combo-card__slot-num">' +
          (index + 1) +
          '</span>' +
          '<div class="viimpii-combo-card__slot-main">' +
          thumb +
          '<div class="viimpii-combo-card__slot-meta">' +
          '<span class="viimpii-combo-card__slot-label">' +
          escapeHtml(item.name) +
          '</span>' +
          view +
          '</div></div>';
      });

      var max = Number(card.getAttribute('data-combo-max') || 2);
      var ready = selected.length >= max;
      var hint = card.querySelector('[data-combo-hint]');
      if (hint) {
        hint.textContent = ready
          ? 'Duo ready — add to cart'
          : 'Select ' +
            (max - selected.length) +
            ' more · tap ✦ to preview';
        hint.classList.toggle('is-ready', ready);
      }

      var cta = card.querySelector('[data-combo-add]');
      if (cta) {
        cta.disabled = !ready;
        cta.classList.toggle('is-ready', ready);
        if (!cta.classList.contains('is-loading')) {
          cta.textContent = ready ? 'Add combo to cart' : 'Pick 2 shades';
        }
      }
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-combo-peek-close]')) {
        e.preventDefault();
        closePeek();
        return;
      }

      var peekSelect = e.target.closest('[data-combo-peek-select]');
      if (peekSelect) {
        e.preventDefault();
        if (peekState.shade && peekState.card) {
          if (!peekState.shade.classList.contains('is-selected')) {
            toggleShade(peekState.shade, peekState.card);
          }
        }
        closePeek();
        return;
      }

      var peekBtn = e.target.closest('[data-combo-peek]');
      if (peekBtn) {
        e.preventDefault();
        e.stopPropagation();
        var wrap = peekBtn.closest('.viimpii-combo-shade-wrap');
        var shadeFromPeek = wrap ? wrap.querySelector('[data-combo-shade]') : null;
        var cardFromPeek = peekBtn.closest('[data-combo-card]');
        if (shadeFromPeek) openPeekFromShade(shadeFromPeek, cardFromPeek);
        return;
      }

      var slotPeek = e.target.closest('[data-combo-slot-peek]');
      if (slotPeek) {
        e.preventDefault();
        var cardForSlot = slotPeek.closest('[data-combo-card]');
        var vid = slotPeek.getAttribute('data-variant-id');
        var shadeForSlot = cardForSlot
          ? cardForSlot.querySelector('[data-combo-shade][data-variant-id="' + vid + '"]')
          : null;
        if (shadeForSlot) openPeekFromShade(shadeForSlot, cardForSlot);
        return;
      }

      var shadeBtn = e.target.closest('[data-combo-shade]');
      if (shadeBtn) {
        var card = shadeBtn.closest('[data-combo-card]');
        if (!card) return;
        e.preventDefault();
        toggleShade(shadeBtn, card);
        return;
      }

      var btn = e.target.closest('[data-combo-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      if (btn.disabled || btn.classList.contains('is-loading')) return;

      var addCard = btn.closest('[data-combo-card]');
      if (!addCard) return;
      var title = btn.getAttribute('data-combo-title') || addCard.getAttribute('data-combo-title') || 'Combo';
      var priceLabel = addCard.getAttribute('data-combo-price-label') || '';
      var comboCode = addCard.getAttribute('data-combo-discount-code') || '';
      var selected = [];
      addCard.querySelectorAll('[data-combo-shade].is-selected').forEach(function (el) {
        var id = Number(el.getAttribute('data-variant-id') || 0);
        if (id) selected.push(id);
      });
      if (selected.length < 2) return;

      var pairId = 'combo-' + Date.now() + '-' + Math.floor(Math.random() * 9999);
      var items = selected.map(function (id) {
        return {
          id: id,
          quantity: 1,
          properties: {
            Combo: title + (priceLabel ? ' · ' + priceLabel : ''),
            _Combo: title,
            '_Combo Pair': pairId,
            '_Combo Discount': comboCode
          }
        };
      });

      var label = btn.textContent;
      btn.classList.add('is-loading');
      btn.textContent = 'Adding…';
      setCartPriceLoading(true);

      // Clear BYOB/old codes, add duo, apply combo code only (no automatic stacking)
      clearStickyByobDiscount()
        .then(function () {
          return addMultipleToCart(items);
        })
        .then(function () {
          if (!comboCode) return null;
          return applyPromoDiscountCode(comboCode, 'combo_discount_code');
        })
        .then(function (cart) {
          return fetch(cartRoot() + 'cart.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (fresh) {
              dispatchCartUpdate(fresh, items[0].id, cart && cart.sections);
              btn.textContent = 'Added ✓';
              openCartDrawer();
              setTimeout(function () {
                btn.textContent = label;
                btn.classList.remove('is-loading');
                renderCard(addCard);
                setCartPriceLoading(false);
              }, 1400);
            });
        })
        .catch(function () {
          btn.textContent = 'Try again';
          btn.classList.remove('is-loading');
          setCartPriceLoading(false);
          setTimeout(function () {
            btn.textContent = label;
            renderCard(addCard);
          }, 1600);
        });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePeek();
    });

    document.querySelectorAll('[data-combo-card]').forEach(renderCard);
  }

  /**
   * BYOB discount shows in cart drawer but often drops on Checkout.
   * Force /checkout?discount=BYOBxOFFy ONLY when cart still has BYOB items.
   */
  function initByobCheckoutBridge() {
    if (window.__viimpiiByobCheckoutBridge) return;
    window.__viimpiiByobCheckoutBridge = true;

    function readRemembered() {
      try {
        return sessionStorage.getItem('viimpii_byob_discount') || '';
      } catch (e) {
        return '';
      }
    }

    function codeFromCart(cart) {
      if (!cart || !isByobDiscountValid(cart)) return '';
      var attrs = cart.attributes || {};
      if (attrs.byob_discount_code) return String(attrs.byob_discount_code);
      if (attrs._byob_discount_code) return String(attrs._byob_discount_code);
      var codes = cart.discount_codes || [];
      for (var i = 0; i < codes.length; i++) {
        var c = String(codes[i].code || '');
        if (c.toUpperCase().indexOf('BYOB') === 0) return c;
      }
      var items = cart.items || [];
      for (var k = 0; k < items.length; k++) {
        var props = items[k].properties || {};
        if (props['_BYOB Discount']) return String(props['_BYOB Discount']);
      }
      return readRemembered();
    }

    function goCheckout(code) {
      var url = cartRoot() + 'checkout';
      if (code) url += (url.indexOf('?') >= 0 ? '&' : '?') + 'discount=' + encodeURIComponent(code);
      window.location.href = url;
    }

    document.addEventListener(
      'click',
      function (e) {
        var el = e.target.closest('#checkout, [name="checkout"], .cart__checkout-button, a[href*="/checkout"]');
        if (!el) return;
        e.preventDefault();
        e.stopPropagation();
        fetch(cartRoot() + 'cart.js', { credentials: 'same-origin' })
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            if (!isByobDiscountValid(cart)) {
              // Incomplete / oversized / normal cart — never re-attach a stuck BYOB code
              clearStickyByobDiscount().finally(function () {
                goCheckout('');
              });
              return;
            }
            goCheckout(codeFromCart(cart));
          })
          .catch(function () {
            goCheckout('');
          });
      },
      true
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    initScrollToTopOnReload();
    initShopMegaMenu();
    initMixedViewAll();
    initFaq();
    initSmoothScroll();
    initScrollReveal();
    initAboutPage();
    initShadeFinder();
    initVideoReviews();
    initQuickView();
    initNewsletterPopup();
    initBuyNow();
    initAjaxCartForms();
    initMobileNav();
    initDrawerBrand();
    initViimpiiCartDrawer();
    initHeroLuxury();
    initLuxuryLinesParallax();
    initMainLinesCarousel();
    initMainLineCards();
    initLineCollection();
    initShopCards();
    watchShopCardGrid();
    initInstagramFeed();
    initComboEdit();
    initComboCartGuard();
    initByobCheckoutBridge();
  });
})();
